import { grey } from '@mui/material/colors';

export const colors = {
  background: {
    default: '#FFFFFF',
  },
  primary: {
    light: '#C5E8C7',
    main: '#39A949',
    dark: '#1B5426',
    contrastText: '#ffffff',
    900: '#092111',
    800: '#0F3218',
    700: '#1B5426', // dark
    600: '#277634',
    500: '#39A949', // main
    400: '#75C47F',
    300: '#9DD6A3',
    200: '#C5E8C7', // light
    100: '#EDFAEB',
    50: '#F6FDF5',
  },
  secondary: {
    light: '#D3D3D3',
    main: '#5B5B5B',
    dark: '#323232',
    contrastText: '#ffffff',
    900: '#323232', // dark
    800: '#5B5B5B', // main
    700: '#707070',
    600: '#848484',
    500: '#979797',
    400: '#ABABAB',
    300: '#BFBFBF',
    200: '#D3D3D3', // light
    100: '#E8E8E8',
    50: '#F7F7F7',
  },
  tertiary: {
    900: '#3E4F69',
    800: '#506687',
    700: '#5B7499',
    600: '#6D85A8',
    500: '#8599B6',
    400: '#9DADC4',
    300: '#B7C3D4',
    200: '#D5DCE6', // shadow
    100: '#E8EDF3', // background
    50: '#F6F8FA', // background
  },
  info: {
    light: '#F3F4FC',
    main: '#1B2D77',
    dark: '#101B47',
  },
  error: {
    light: '#FFE8E8',
    main: '#AE2E2E',
    dark: '#6D1C1C',
  },
  success: {
    light: '#F6FDF5',
    main: '#39A949',
    dark: '#1B5426',
  },
  warning: {
    light: '#FAF0C6',
    main: '#CAA402',
    dark: '#7A6301',
  },
  text: {
    primary: '#323232',
    secondary: '#5B5B5B',
  },
  grey: {
    ...grey,
    50: '#F7F7F7',
    100: '#E8E8E8',
    200: '#D3D3D3',
    300: '#BFBFBF',
    400: '#ABABAB',
    500: '#979797',
    600: '#848484',
    700: '#707070',
    800: '#5B5B5B',
    900: '#323232',
  },
  input: {
    background: '#718096',
  },
};
